import { render, staticRenderFns } from "./questionPaperPreview.vue?vue&type=template&id=1f6ec18c&scoped=true"
import script from "./questionPaperPreview.vue?vue&type=script&lang=js"
export * from "./questionPaperPreview.vue?vue&type=script&lang=js"
import style0 from "./questionPaperPreview.vue?vue&type=style&index=0&id=1f6ec18c&prod&scoped=true&lang=css"
import style1 from "./questionPaperPreview.vue?vue&type=style&index=1&id=1f6ec18c&prod&lang=css"
import style2 from "./questionPaperPreview.vue?vue&type=style&index=2&id=1f6ec18c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ec18c",
  null
  
)

export default component.exports